import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://szqqlkthebrmuiyrbhhn.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6cXFsa3RoZWJybXVpeXJiaGhuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODk0OTY5NDQsImV4cCI6MjEwNTA3Mjk0NH0._V2xPfNFO2OFJq702C5wOXMSIt6BFmU0YZG-gh1qTsc';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});